
// 表格 列配置
export const ReportListConfig = [
    {
        label: "受理编号",
        field: "serialNumber"
    },
    {
        label: "举报机构",
        field: "agencyName"
    },
    {
        label: "事项及理由",
        field: "reportReason"
        // tags 显示标签
        // tabletype: "tags"
    },
    {
        label: "举报时间",
        field: "createdTime"
    },
    {
        label: "举报联系人",
        field: "reportName"
    },
    {
        label: "身份证号",
        field: "reportIdNumber"
    },
    {
        label: "联系电话",
        field: "reportPhone"
    }
]